export default "__VITE_ASSET__Bo1LZ7QB__"